<div class="pl-[16px] pb-[16px] pt-[16px] w-full bg-gray-100">
  {{value || '&#8203;'}}
</div>
